module.exports.supportedLanguages = [
  { code: 'en', language: 'English' },
  // { code: 'es', language: 'Spanish' },
  // { code: 'ja', language: 'Japanese' },
  // { code: 'fr', language: 'French' },
  // { code: 'ru', language: 'Russian' },
  // { code: 'zh-CN', language: 'Chinese-simplified' }
];
